import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter, Link } from "react-router-dom";
import SimpleBar from "simplebar-react";
import SidebarContent from "./SidebarContent";
import SidebarPairAccountCta from "./SidebarPairAccountCta";
import logolight from "../../assets/images/Expanded_WhiteOrange_Curve.png";
import logodark from "../../assets/images/logo-main.jpg";

class Sidebar extends Component {
  render() {
    const theme = this.props.theme;
    const isModernDark = theme === "modern-dark";
    const isShadcnLight = theme === "shadcn-light";
    const showSidebarHeader = isModernDark;
    const logoSrc = isShadcnLight ? logodark : logolight;
    const isCollapsed = this.props.type === "condensed";

    return (
      <React.Fragment>
        <div className="vertical-menu sidebar-modern sidebar-with-footer">
          {showSidebarHeader && (
            <div className="sidebar-header">
              <Link to="/dashboard" className="sidebar-brand">
                <img src={logoSrc} alt="CLOUD CATCHER" className="sidebar-brand-lg" />
              </Link>
            </div>
          )}
          <div data-simplebar className="h-100 sidebar-scroll">
            {isCollapsed ? (
              <SidebarContent menuType="condensed" isCollapsed={true} />
            ) : (
              <SimpleBar style={{ maxHeight: "100%" }}>
                <SidebarContent
                  menuType={this.props.type}
                  isCollapsed={false}
                />
              </SimpleBar>
            )}
          </div>
          <SidebarPairAccountCta isCollapsed={isCollapsed} />
        </div>
      </React.Fragment>
    );
  }
}

const mapStatetoProps = (state) => ({
  layout: state.layout,
  theme: state.layout?.leftSideBarTheme,
});
export default connect(mapStatetoProps, {})(withRouter(Sidebar));
